<template>
  <side-panel width="450px" @close="$emit('close', true)">
    <template #title>
      <h2 class="text-h2">{{ $t('components.notifications.header') }}</h2>
    </template>
    <template #content>
      <div class="text-center">
        <v-btn
          variant="text"
          block
          class="ml-auto"
          @click="clearNotifications()"
          color="secondary"
        >
            {{ $t('components.notifications.clear') }}
        </v-btn>
      </div>
      <div class="notification-content">
      <div class="notification-content-title">
        {{ $t('components.notifications.recent') }}
      </div>
      <div class="notification" v-for="(n, i) in recentNotifications" v-bind:key="'recent-' + i">
        <div class="notification-text">
          {{ $t(`notifications.${n.action}.description`, n.metadata) }}
        </div>
        <div class="notification-date">{{ new Date(n.created_at).toLocaleString() }}</div>
        <div v-if="n.link">
          <a :href="n.link" @click="$emit('close', true)">
          {{ $t(`notifications.${n.action}.link_title`, n.metadata) }}
          </a>
        </div>
      </div>
      <div class="notification-empty" v-if="recentNotifications.length === 0">
        {{ $t('components.notifications.nothing_to_see') }}
      </div>
      <div class="notification-content-title">
        {{ $t('components.notifications.other') }}
      </div>
      <div class="notification" v-for="(n, i) in otherNotifications" v-bind:key="'other-' + i">
        <div class="notification-text">
          {{ $t(`notifications.${n.action}.description`, n.metadata) }}
        </div>
        <div class="notification-date">{{ new Date(n.created_at).toLocaleString() }}</div>
        <div>
          <a :href="n.link" @click="$emit('close', true)">
            {{ $t(`notifications.${n.action}.link_title`, n.metadata) }}
          </a>
        </div>
      </div>
      <div class="notification-empty" v-if="otherNotifications.length === 0">
        {{ $t('components.notifications.nothing_to_see') }}
      </div>
    </div>
    </template>
  </side-panel>
</template>
<script>
import SidePanel from "@/components/SidePanel.vue";

export default {
  name: 'NotificationInbox',
  components: {SidePanel},
  data() {
    return {
    };
  },
  computed: {
    notifications() {
      return this.$store.getters['notifications/notifications'];
    },
    recentNotifications() {
      if (!this.notifications) return [];
      return this.notifications.filter(n => !n.seen);
    },
    otherNotifications() {
      if (!this.notifications) return [];
      return this.notifications.filter(n => n.seen);
    },
  },
  methods: {
    async clearNotifications() {
      await this.$store.dispatch('notifications/checkNotifications');
    },
  },
  async beforeUnmount() {
    await this.$store.dispatch('notifications/checkNotifications');
  },
};
</script>
<style lang="css" scoped>
.notification-header > h1 {
  display: inline-block;
}

.notification-content-title {
  background: var(--light-grey);
  text-align: center;
  padding: 5px;
  font-weight: bold;
  color: #a0a0a0;
}
.notification {
  padding: 5px 0 10px 0;
}
.notification, .notification-content-title, .notification-empty {
  border-bottom: 1px solid var(--grey);
}
.notification-date {
  color: var(--text-color-grey);
  font-size: 0.8em;
}
.notification-empty {
  color: var(--text-color-grey);
  padding: 10px;
}
</style>
